import {
  FETCH_PAYMENT_METHOD,
  SUBMIT_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD,
  REFRESH_PAYMENT_METHOD_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function paymentMethod(state = initialState, action) {
  switch (action.type) {
    case FETCH_PAYMENT_METHOD:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_PAYMENT_METHOD:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_PAYMENT_METHOD:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_PAYMENT_METHOD_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
